import { request } from "../Request";
import { routes } from "../../constants/constant.route";
import { urlConstants } from "../../utils/urlConstants";
import { postStudentHistoryOnce } from "../StudentHistoryService";
const {API_URL } = urlConstants;

export default class GetStudentService {
  static deleteSpecificGroup(body) {
    return request(
      "DELETE",
      `${API_URL}${routes.studentgoal.deleteSpecificGroup}`,
      null,
      body,
      null
    );
  }
  static getDetails(body) {
    // Once per login session
    return postStudentHistoryOnce({
      ...body,
      logged_in_user_id: body?.logged_in_user_id || body?.student_id || null,
    });
  }
  static getStudent(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.getStudentForCounselor}`,
      null,
      body,
      null,
      null
    );
  }
  static getData(school,goal_id){
    return request(
      "GET",
      `${API_URL}${routes.counselor.getData}?school_id=${school}&goal_id=${goal_id}`,
      null,
      null,
      null
    )
  }
  static getWatchlistStudent(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.addToWatchlist}`,
      null,
      body,
      null,
      null
    );
  }
  static getStudentGoalRequirement(id) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.studentgoal_requirement}?student_id=${id}`,
      null,
      null,
      null,
      null
    );
  }
  static getWatchDisplay(obj) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.addToWatchlist}?counselor=${obj.counselor}&page=${obj.page}&goal_id=${obj.goal_id}${obj.color !== undefined ? `&color=${obj.color}` : ''}${obj.student_search ? `&student_search=${obj.student_search}` : ''}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentdataPerId(id) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.studentdataperId}?student=${id}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentPublishGoal(id) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.goalPublishManage}?manage=${id}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentProgress({ student_id, goal_id, school_id }) {
    return request(
      "GET",
      `${API_URL}${routes.studentgoal.student_progress}?student_id=${student_id}&goal_id=${goal_id}&school_id=${school_id}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentFailList(body) {
    return request(
      "POST",
      `${API_URL}${routes.studentgoal.fail_list}`,
      null,
      body,
      null,
      null
    );
  }
  static getMigrateStatus(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.studentmigrate_status}`,
      null,
      body,
      null,
      null
    );
  }
  static getStudentGoal(student, school) {
    return request(
      "GET",
      `${API_URL}${routes.studentgoal.studentgoal}?student_id=${student}&school_id=${school}`
    );
  }
  static getStudentGoalInfo(goalId, school) {
    return request(
      "GET",
      `${API_URL}${routes.studentgoal.goaldata}?goal_id=${goalId}&school_id=${school}`
    );
  }
  static getGroupPage(obj) {
    return request(
      "GET",
      `${API_URL}${routes.studentgoal.getGroupPage}?school=${obj.school}&counselor=${obj.counselor}&page=${obj.page}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentForCreatingGroup(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.getStudent}`,
      null,
      body,
      null,
      null
    );
  }
  static saveGroup(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.saveGroup}`,
      null,
      body,
      null,
      null
    );
  }
  static getCurrentStudentPage(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.currentStudent}`,
      null,
      body,
      null,
      null
    );
  }
  static getStudentAllPdf(obj) {
    return request(
      "GET",
      `${API_URL}${
        routes.counselor.allStudentPDF
      }?counselor_id=${obj.counselor_id}&school_id=${obj.school_id}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentPdf(obj) {
    return request(
      "GET",
      `${API_URL}${
        routes.counselor.allStudentPDF
      }?user_id=${obj.user_id}`,
      null,
      null,
      null,
      null
    );
  }
  static sendSingleInvite(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.send_single_invite}`,
      null,
      body,
      null,
      null
    );
  }
  static getAddExistingStudent(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.add_existing_student_list}`,
      // ?counselor=${counselor}&q=${parameter}&role=${role}&school=${school},
      null,
      body,
      null,
      null
    );
  }
  static addExistingStudent(body) {
    return request(
      "POST",
      `${API_URL}${routes.counselor.add_existing_student}`,
      null,
      body,
      null,
      null
    );
  }
  static downloadStudentFile(school) {
    return request(
      "GET",
      `${API_URL}${
        routes.counselor.studentdataperId
      }?school_id=${school}`,
      // ?counselor=${counselor}&limit=${1000}&school=${school}`,
      null,
      null,
      null,
      null
    );
  }
  static getStudentListForCouselor(value, school) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.getStudentListForCounselor}q=${value}&school_id=${school}`,
      null,
      null,
      null,
      null
    );
  }

  static getGoal(goalId, school) {
    return request(
      "GET",
      `${API_URL}${routes.studentgoal.goal}?goal_id=${goalId}&school_id=${school}`,
      null,
      null,
      null,
      null
    );
  }

  static getDifferentGoal(school) {
    return request(
      "GET",
      `${API_URL}${routes.counselor.status_calculation}?school_id=${school}`,
      null,
      null,
      null,
      null
    );
  }
}
